/** Rules of the named item dialog. */

export const validateNamedItemName = (name: string): string | null => {
  if (!name) return 'Name is required';
  if (name.length < 2) return 'Name must be at least 2 characters';
  if (name.length > 100) return 'Name must be at most 100 characters';
  return null;
};
